<!-- Beroepen in cijfers -->
@if (shouldShowCharts()) {
  <section class="o-wrapper" id="occupational-profile-charts"
    >
    @if (!errorState) {
      <div class="o-1-col" id="cijfers">
        <h2  id="in-cijfers" >{{occupationalProfile.title?.nl}} in cijfers</h2>
      </div>
      <div class="c-evolution">
        <div id="id_div_chart_2" style="margin:auto;"></div> <!-- content is set by javascript -->
      </div>
      <br/>
      <br/>
      <div class="o-1-col c-knelpuntberoep">
        <div id="id_div_chart_4" style="margin:auto;"></div> <!-- content is set by javascript -->
      </div>
      <br/>
      <br/>
      <div class="c-vacatures-vs-werkzoekende">
        <div id="id_div_chart_1" style="margin:auto;"></div> <!-- content is set by javascript -->
      </div>
      <br/>
      <br/>
      <div class="c-pie-chart__container">
        <div id="id_div_chart_3" style="margin:auto;"></div> <!-- content is set by javascript -->
      </div>
      <div class="c-divider"></div>
      <br/>
      <a id="id_a_chart_3" style="display:none;float:left;padding:20px;height:100%;" target="_blank">Bekijk alle cijfers ></a>
    }
    @if (errorState) {
      <div class="c-statistiek-error">
        <div class="c-statistiek-error__image-container">
          <img class="c-statistiek-error__image" src="/cdn/img/beroepenfiche/statistiekwidget-foutmelding.svg" alt="">
        </div>
        <div class="c-statistiek-error__content">
          <h2 class="mt0">{{occupationalProfile.title?.nl}} in cijfers</h2>
          <p>
            Door een technisch probleem kunnen we de cijfers voor {{occupationalProfile.title?.nl}} niet tonen.
            Probeer later opnieuw.
          </p>
        </div>
      </div>
    }
  </section>
}
